export default "__VITE_ASSET__d1044b3c__"